import React from 'react'
import PropTypes from 'prop-types'

import SingleStudyGoalSkeleton from './SingleStudyGoalSkeleton'

export const StudyGoalTitle = ({ children }) => children

const SingleStudyGoal = ({
  title,
  numericProgressSection,
  progressBarSection,
}) => {
  return (
    <SingleStudyGoalSkeleton
      title={title}
      numericProgressSection={numericProgressSection}
      progressBarSection={progressBarSection}
    />
  )
}

SingleStudyGoal.propTypes = {
  title: PropTypes.string.isRequired,
  numericProgressSection: PropTypes.any,
  progressBarSection: PropTypes.any,
}

export default SingleStudyGoal
